import { useReducer } from "react";

import responseReducer, {
  init,
  initialState,
  PENDING,
  REJECTED,
  FULFILLED,
} from "common/hooks/fetch/fetch.reducer";
import { usePost } from "common/hooks/fetch/fetch-manual.hooks";

import { getLocalStorageItem } from "common/utils/storage/local-storage";

import { CURRENT_BUDGET } from "features/budget/budget.constants";
import { getCompanyStructure } from "features/budget/company-structure/state/company-structure.storage";
import { getOwnerAssignments } from "features/budget/owners/state/owners.storage";

function useFinishScenario() {
  const [state, dispatch] = useReducer(
    responseReducer,
    { ...initialState, loading: false },
    init,
  );
  const post = usePost();

  async function finishScenario() {
    const id = getLocalStorageItem(CURRENT_BUDGET);

    const companyStructure = await getCompanyStructure();
    const ownerAssignments = await getOwnerAssignments();
    const templateOrganizations =
      ownerAssignments === undefined
        ? null
        : Object.entries(ownerAssignments).map(([organizationId, userId]) => ({
            organizationId,
            userTemplates: [{ userId }],
          }));

    const ownersBody = {
      budgetScenarioId: id,
      organizationId: companyStructure.id,
      templateOrganizations,
    };

    const finishBody = {
      id: Number(id),
    };

    dispatch({ type: PENDING });
    let response;
    try {
      await post("budgetScenario/organization/user", ownersBody);
      response = await post("budgetScenario/finish", finishBody);
    } catch (error) {
      dispatch({ type: REJECTED, payload: error });
      return;
    }

    dispatch({ type: FULFILLED, payload: response });
  }

  return { ...state, finishScenario };
}

export default useFinishScenario;
